import React from "react";
import {Page} from "../../components/page/page";
import styles from "./love-language.module.css";
import {ChooseButton} from "../../components/choose-button/choose-button";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";

const options = [
    {
        value: "Words of affirmation",
        icon: "💌",
    },
    {
        value: "Quality time together",
        icon: "⏰",
    },
    {
        value: "Physical touch",
        icon: "🤝",
    },
    {
        value: "Gifts",
        icon: "🎁",
    },
    {
        value: "Acts of service",
        icon: "🛠️",
    },
];

const LoveLanguagePage = () => {
    const dispatch = useDispatch();
    return (
        <Page
            title="What is your love language?"
            hideContinueButton={true}
            currentStep="13"
        >
            <ul className={styles.list}>
                {options.map((option, i) => (
                    <li key={i}>
                        <Link
                            to="../tend-to-overthink"
                            // onClick={() => dispatch((option.value))} TODO
                        >
                            <ChooseButton icon={option.icon}>{option.value}
                                <svg className={styles.arrow_icon} width="12" height="12"
                                     viewBox="0 0 12 12" fill="none">
                                    <g clip-path="url(#clip0_1973_11047)">
                                        <path d="M4 0.799219L9.6 5.99922L4 11.1992" stroke="black"
                                              stroke-linecap="square"></path>
                                    </g>
                                    <defs>
                                        <clipPath>
                                            <rect width="12" height="12" fill="white"
                                                  transform="translate(0 12) rotate(-90)"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </ChooseButton>
                        </Link>
                    </li>
                ))}
            </ul>
        </Page>
    );
};

export {LoveLanguagePage};
